import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------retainer invoice page api's-------------------------------->
    /**
     * 
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getRetainers(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/retainerinvoice/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getRetainersExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/retainerinvoice/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    /**
     * retainer invoice deails
     */
    getRetainerInvoiceDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/retainerinvoice/RetainerInvoiceDetails')
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postRetainerInvoiceUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/update/' + id, form)
    },
    /**
     * create api 
     * @param {*} form 
     */
    postRetainerInvoice(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/create', form)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getRetainerInvoice(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/retainerinvoice/view/' + id)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getRetainerInvoiceView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/retainerinvoice/viewpage/' + id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postRetainerPaymentUpdate(id, form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/recordpayment/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postRetainerRefundUpdate(id, form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/refundcreate/' + id, form)
    },
    /**
     * 
     * @param {*} data 
     */
    postFiltercreateRetainerInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateRetainerInvoice(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteRetainerInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/filterdelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postRetainerRefundDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/refunddelete/' + id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getRetainerDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/singledelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postRetainerBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/retainerinvoice/bulkdelete', data)
    },
    getQuotationDetails(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/quotation/retainerview/' + id)
    }

}